module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "services"
    }
  }, [_c('f7-navbar', {
    attrs: {
      "sliding": ""
    }
  }, [_c('f7-nav-left', [_c('f7-link', {
    attrs: {
      "icon": "icon-bars",
      "open-panel": "left"
    }
  })], 1), _vm._v(" "), _c('f7-nav-center', [_vm._v("\n      Services\n    ")])], 1), _vm._v(" "), _c('f7-block-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('f7-block', {
    attrs: {
      "inner": ""
    }
  }, [_vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n    Distinctio est aliquam officiis quaerat placeat, cum explicabo magni\n    soluta totam maxime autem minima accusamus eos suscipit dignissimos\n    corporis modi voluptatum fugiat!\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01139f3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Services.vue
// module id = 323
// module chunks = 2